import { key } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IRelationship, Relationship } from 'utility-ts-datasource';
import { APCourse } from '../../global/builders/ap_course_builder';
import { APTerm } from '../../global/builders/ap_term_builder';
import { IAPCoursesDatasource } from '../../global/datasources/ap_courses_datasource';
import { IAPTermsDatasource } from '../../global/datasources/ap_terms_datasource';

export interface IAPCoursesTermsRelationship extends IRelationship<APCourse, APTerm> {}

angular
  .module('capability-ng-academic-planner')
  .factory(
    'ngAPCoursesTermsRelationship',
    (ngAPCoursesDatasource: IAPCoursesDatasource, ngAPTermsDatasource: IAPTermsDatasource) =>
      new Relationship(ngAPCoursesDatasource, ngAPTermsDatasource).includeModel({
        mapTermToCourse: []
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/relationship/ap_courses_terms_relationship.ts